import { useQuery } from "@tanstack/react-query";
import { VIEW_PARCEL } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { ICurrentShipment } from "@/types/apiResponse.types";

export const useGetViewParcelRequest = (parcelId: number) => {
  return useQuery<{
    data: {
      data: ICurrentShipment;
    };
  }>({
    queryKey: [VIEW_PARCEL, parcelId],
    queryFn: () =>
      apiRequest(VIEW_PARCEL, "get", {
        shipmentId: parcelId,
      }),
    enabled: !!parcelId,
  });
};
